import { PropsWithChildren, ReactNode } from 'react';

import { ChakraToolTip } from '@equip.health/ui';

interface NavTooltipProps extends PropsWithChildren {
  id: string;
  renderTooltip: boolean;
  isHidden?: boolean;
  tooltipText: string;
  children: ReactNode;
  marginLeft?: string;
}

export default function NavTooltip({
  children,
  id,
  isHidden = false,
  marginLeft,
  renderTooltip = false,
  tooltipText,
}: NavTooltipProps) {
  if (!renderTooltip) {
    return <>{children}</>;
  }

  return (
    <ChakraToolTip
      {...(marginLeft && { marginLeft })}
      bg="background.dark.90.variant"
      borderRadius="100px"
      color="neutral.background.primary"
      fontSize="13px"
      hidden={isHidden}
      id={`${id}__menu-item-tooltip`}
      label={tooltipText}
      marginTop="-2px"
      maxWidth="320px"
      padding="11px 16px"
      placement="left-start"
      shouldWrapChildren
    >
      {children}
    </ChakraToolTip>
  );
}
